import {ApiUrlInfo, EnvironmentDetails} from '@uofu-uss/ngx-auth';


export const credentials: Readonly<EnvironmentDetails> = {
  local: {
    clientId: '8a5kQ2XB937Akf2zI752tl7htbca',
    clientSecret: 'cYevwGG8KxbJmTATJ0U_9LEVA2Ua',
    appUrl: 'http://localhost:4200/'
  },
  dev: {
    clientId: 'CLY_8D6I7itkCM51NNjJuwq9jZsa',
    clientSecret: 'nZlfUarZtWZfWwC0E8sMy5fGjJMa',
    appUrl: 'https://software-catalog.app.dev.utah.edu/'
  },
  test: {
    clientId: 'Guf74w6UyzxRlq28uYfA98zkKPQa',
    clientSecret: 'B3kEDPRUonYDrbDSR_bE9Ef0xQca',
    appUrl: 'https://software-catalog.app.test.utah.edu/'
  },
  qa: {
    clientId: '',
    clientSecret: '',
    appUrl: 'https://software-catalog.app.qa.utah.edu/'
  },
  disaster_recovery: {
    clientId: '',
    clientSecret: '',
    appUrl: 'https://software-catalog.app.sys.utah.edu/'
  },
  prod: {
    clientId: 'uKDog2GypXGIU5JLt14BM5OP1rsa',
    clientSecret: 'ilA1ugwYpt1APXnRfXjSUUkzThAa',
    appUrl: 'https://software-catalog.app.utah.edu/'
  }
};

export const softwareCatalogApisPath: ReadonlyArray<ApiUrlInfo> = [
  {
    relativeUrl: '/api/',
    relativeGatewayUrl: '/software-catalog/1.0.0{env}/',
  },
];
